import * as React from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { IconButton, CircularProgress, Button } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import DocViewer from "@cyntler/react-doc-viewer";
import { Download } from "@mui/icons-material";
import { show_proper_words } from "../../utils/Constant";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90vw",
  maxWidth: 1000,
  height: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: 2,
  display: "flex",
  flexDirection: "column",
  outline: "none",
};

export default function DocumentModalboxCv({
  open,
  handleClose,
  image_url,
  type,
  previewDoc,
}) {
  console.log(previewDoc, "previewDocpreviewDocpreviewDoc");
  const docs = [{ uri: image_url }];
  const fileExtension = image_url?.split(".").pop().toLowerCase();
  console.log(docs, "docsdocsdocsdocsdocsdocs");
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-title"
      aria-describedby="modal-desc"
    >
      <Box sx={style} mb={4}>
        {/* Header with Download and Close */}
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 1,
            mt: 1,
            mr: 1,
          }}
        >
          {/* Candidate Name */}
          <Box
            sx={{
              ml: 1,
              fontWeight: "bold",
              fontSize: 22,
              color: "#000",
              pl: 1,
            }}
          >
            {(() => {
              let firstName = previewDoc?.firs_name
                ? previewDoc.firs_name.trim() || previewDoc.name
                : "";
              let lastName = previewDoc?.last_name
                ? previewDoc.last_name.trim().replace(/\s+/g, "_")
                : "";
              if (["N/A", "NA", "n/a", "na"].includes(lastName.toUpperCase())) {
                lastName = "";
              }
              // Only show if lastName exists and is not "N/A" or "NA"
              if (lastName !== "N/A" && lastName !== "NA") {
                let displayName = (firstName + " " + lastName).trim();
                return show_proper_words(
                  displayName || previewDoc?.name || "CV"
                );
              } else {
                return show_proper_words(previewDoc?.firs_name);
              }
              return ""; // Show nothing if lastName is not present or is "N/A"/"NA"
            })()}
          </Box>
          <Box sx={{ display: "flex", alignItems: "center" }}>
            {image_url && (
              <Button
                startIcon={<Download />}
                onClick={async () => {
                  try {
                    const response = await fetch(image_url, { mode: "cors" });
                    if (!response.ok)
                      throw new Error("Network response was not ok");
                    const blob = await response.blob();
                    const url = window.URL.createObjectURL(blob);
                    // Build file name from previewDoc
                    let firstName = previewDoc?.firs_name
                      ? previewDoc.firs_name.trim().replace(/\s+/g, "_")
                      : "";
                    let lastName = previewDoc?.last_name
                      ? previewDoc.last_name.trim().replace(/\s+/g, "_")
                      : "";
                    if (
                      ["N/A", "NA", "n/a", "na"].includes(
                        lastName.toUpperCase()
                      )
                    ) {
                      lastName = "";
                    }
                    let fullName =
                      (firstName + (lastName ? "_" + lastName : "")).replace(
                        /_+/g,
                        "_"
                      ) ||
                      previewDoc?.name ||
                      "cv";
                    let ext = image_url.split(".").pop().split("?")[0];
                    const fileName = `CV_${fullName}.${ext}`;
                    const link = document.createElement("a");
                    link.href = url;
                    link.download = fileName;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                    window.URL.revokeObjectURL(url);
                  } catch (err) {
                    alert("Failed to download CV.");
                  }
                }}
                color="primary"
                variant="contained"
                size="small"
                sx={{ mr: 1 }}
              >
                Download
              </Button>
            )}
            <IconButton
              onClick={handleClose}
              sx={{
                backgroundColor: "navy",
                fontSize: "10px",
                padding: "3px !important",
                "&:hover": { backgroundColor: "navy" },
                ml: 1,
              }}
              aria-label="close"
            >
              <CloseIcon style={{ color: "white" }} fontSize="small" />
            </IconButton>
          </Box>
        </Box>

        {/* Image Preview */}

        {/* PDF or Other Document Viewer */}
        {fileExtension === "pdf" ? (
          <iframe
            className="iframe-content"
            src={image_url}
            title="PDF Viewer"
            width="100%"
            height="100%"
            style={{ border: "none", flex: 1 }}
          />
        ) : fileExtension === "doc" || fileExtension === "docx" ? (
          <iframe
            className="iframe-content"
            src={`https://docs.google.com/gview?url=${encodeURIComponent(
              image_url
            )}&embedded=true`}
            title="DOC/DOCX Viewer"
            width="100%"
            height="100%"
            style={{ border: "none", flex: 1 }}
          />
        ) : (
          <Box sx={{ width: "100%", height: "100%", overflow: "auto" }}>
            <DocViewer
              documents={docs}
              config={{
                header: { disableHeader: true },
              }}
              style={{
                width: "100%",
                minWidth: "fit-content",
                height: "100%",
                flex: 1,
              }}
            />
          </Box>
        )}

        {/* Download Button */}
      </Box>
    </Modal>
  );
}
